import { useState, useEffect } from 'react';

export type DeviceType = 'desktop' | 'tablet' | 'mobile';

/**
 * Hook para detectar o tipo de dispositivo baseado na largura da tela
 *
 * @returns DeviceType - 'mobile' (< 768px), 'tablet' (768px - 1023px), 'desktop' (>= 1024px)
 *
 * @example
 * ```typescript
 * const deviceType = useDeviceDetection();
 *
 * if (deviceType === 'mobile') {
 *   // Renderizar versão mobile
 * }
 * ```
 */
export const useDeviceDetection = (): DeviceType => {
  const [deviceType, setDeviceType] = useState<DeviceType>('desktop');

  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setDeviceType('mobile');
      } else if (width < 1024) {
        setDeviceType('tablet');
      } else {
        setDeviceType('desktop');
      }
    };

    checkDevice();
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  return deviceType;
};
